(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvToolBar', drvToolBar);

    drvToolBar.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvToolBar
     *
     * @description
     * A toolbar for buttons, (and potentially other stuff). Use this for consistent style.
     */
    function drvToolBar() {
        var directive = {
            restrict: 'E',
            transclude: true,
            template: '<div style="background-color: #F1F1F1;"><ng-transclude></ng-transclude></div>'
        };
        return directive;
    }
})();